import styled from 'styled-components'

export const ModalFooter = styled.div`
   display: flex;
   justify-content: flex-end;
   gap: 12px;
   padding: 14px 18px 18px 18px;
   background: #FAFAFB;

   button {
      padding: 10px 24px;
      border-radius: 999px;
      font-size: 14px;
      font-weight: 600;
      cursor: pointer;
      transition: background .15s ease, color .15s ease;
   }

   .cancel {
      background: #F5F5F6;
      color: #3F3F45;
      border: 0;
   }

   .cancel:hover { background: #EDEDEE; }
`